import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "Bina ve site temizliği",
  heroDescription: "Apartman ve site ortak alan temizliği için profesyonel ekip, düzenli hizmet planı ve hijyen odaklı çözümler.",
  description: "Apartman ve site ortak alanları, gün içinde birçok kişi tarafından kullanıldığı için düzenli temizlik gerektirir. Day Temizlik Adana, merdivenler, giriş alanları, asansör çevresi, koridorlar, bina önü ve ortak kullanım alanlarında planlı temizlik hizmeti sunar. Sarıçam ve Adana genelinde bina ve site temizliği için güvenilir, düzenli ve profesyonel çözümler üretiyoruz.",
  scope: [
    "Merdiven temizliği",
    "Bina girişi temizliği",
    "Koridor ve ortak alan temizliği",
    "Asansör çevresi temizliği",
    "Kapı önü ve bina çevresi düzeni",
    "Periyodik temizlik planı",
    "Site ortak kullanım alanları temizliği",
  ],
  forWho: [
    "Apartman yönetimleri",
    "Site yönetimleri",
    "Bina sakinleri",
    "Mülk sahipleri",
    "Kiracı toplulukları",
  ],
  process: [
    "Bina veya site ortak alanlarını yerinde görerek değerlendiriyoruz.",
    "Kullanım yoğunluğuna ve alan büyüklüğüne göre periyodik plan oluşturuyoruz.",
    "Gerekli ekipman ve temizlik maddelerini belirliyoruz.",
    "Belirlenen takvimde düzenli temizlik hizmeti sunuyoruz.",
    "Düzenli kontrol ve geri bildirimle süreci iyileştiriyoruz.",
  ],
  whyProfessional: [
    "Ortak alanların hijyenik kalması sakinlerin sağlığını korur.",
    "Düzenli temizlik bina değerini ve yaşam kalitesini artırır.",
    "Profesyonel planlama sayesinde hizmet aksamaz.",
    "Doğru ekipman ve malzemelerle daha etkili sonuç alınır.",
    "Sakinlerin memnuniyeti yüksek tutulur.",
  ],
  relatedServices: [
    { title: "Apartman Temizliği", path: "/hizmetlerimiz/apartman-temizligi" },
    { title: "Profesyonel Apartman ve Site Yönetimi", path: "/hizmetlerimiz/profesyonel-apartman-ve-site-yonetimi" },
    { title: "İlaçlama", path: "/hizmetlerimiz/ilaclama" },
  ],
  faqs: [
    { question: "Bina temizliği ne sıklıkla yapılmalı?", answer: "Kullanım yoğunluğuna göre haftada bir, iki haftada bir veya aylık düzenli temizlik planlanabilir." },
    { question: "Site temizliği hizmetinde hangi alanlar kapsanır?", answer: "Merdiven, koridor, asansör çevresi, giriş alanları, otopark ve ortak kullanım alanları temizliği yapılır." },
    { question: "Fiyatlar nasıl belirlenir?", answer: "Bina büyüklüğü, kat sayısı, temizlik sıklığı ve alan durumuna göre fiyat belirlenir." },
  ],
  ctaText: "Bina veya siteniz için düzenli temizlik planı oluşturalım.",
  heroImage: "/assets/images/bina-site-temizligi.jpg",
};

export default function BinaSiteTemizligiPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}